/*******************************************************************************
CHECK FOR WALLPAPER AD
Listens to see if a wallpaper ad is being served.
*******************************************************************************/

import activateCloudinaryImages from '../cloudinary/activate';

export default function activateWallpaper(event) {
    if (!event || !event.data || !event.data.wallpaperRW) { return; }

    const wallpaper = event.data.wallpaperRW;
    const { image = '', link = '', code = null } = wallpaper;

    if (!image || !link) { return; }

    const $siteWrapper = $('.site-wrapper');

    $siteWrapper.addClass('wallpaper-is-active').css('background', `url(${image}) #122335 no-repeat fixed top center`);

    $(document).on('click', '.site-wrapper:not(.rwnav-section-side-is-open)', function listenForWallpaperClick(e) {
        if (e.target === this) { window.open(link, '_blank'); }
    });

    activateCloudinaryImages();

    // Adds a custom script tag (optional)
    if (code) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = code;

        document.getElementsByTagName('head')[0].appendChild(script);
    }

    // Trigger a custom event that signals the wallpaper is loaded
    $(document).trigger('rw:wallpaper-loaded', []);

    // Trigger a window resize event so elements on the page can adjust if necessary
    window.dispatchEvent(new Event('resize'));
}

window.addEventListener('message', activateWallpaper, false);
